import { api } from './client'

// FR-28 Phase 3: platform-level institution administration.
// Only reachable by PLATFORM_OWNER — the server rejects everyone else.

export const listTenants = () =>
  api.get('/tenants').then((r) => r.data)

// Creates the institution and its first admin together; the response carries
// a one-time temporary password to hand over.
export const createTenant = (payload) =>
  api.post('/tenants', payload).then((r) => r.data)

export const updateTenant = (id, patch) =>
  api.patch(`/tenants/${id}`, patch).then((r) => r.data)

// Daftar paket beserta fitur bawaannya, dari server. Editor paket memakainya
// untuk menunjukkan apa yang diberikan sebuah paket — supaya tidak ada salinan
// di sini yang bisa menyimpang dari yang benar-benar ditegakkan server.
export const getPlanCatalog = () =>
  api.get('/tenants/catalog').then((r) => r.data)
